import Root from './_root';

const hostStyles = dissolve => `
  :host {
    display: ${dissolve ? 'contents' : 'block'};
  }
  :host *,
  :host *::before, 
  :host *::after {
    box-sizing: inherit;
  }
`;

export default class extends HTMLElement {
  constructor({ dissolve = false } = {}) {
    super();
    const hostStylesheet = new CSSStyleSheet();
    const slot = document.createElement('slot');
    const shadow = this.attachShadow({ mode: 'open', delegatesFocus: false });

    hostStylesheet.replaceSync(hostStyles(dissolve));
    shadow.adoptedStyleSheets = [Root.stylesheet, hostStylesheet];
    shadow.appendChild(slot);
  }
}
